/**
 * Order Import Client Queries Module
 *
 * Barrel export for client-side order import functionality.
 * Exports React Query hooks and TypeScript types.
 */

export * from './queries';
export type {
  OrderImportCommitRequest,
  OrderImportCommitResponse,
  OrderImportArticleSummary,
  OrderImportColorSummary,
  OrderImportLookupResult,
  OrderImportLookupStatus,
  OrderImportProcessResponse,
  OrderImportRevalidateLineInput,
  OrderImportRevalidateRequest,
  OrderImportSourceColumns,
  OrderImportTemplateResponse,
  ProcessedOrderImportLine,
} from './types';

/**
 * React Query key factory for order import queries.
 * Used for cache management and query invalidation.
 */
export const orderImportKeys = {
  /**
   * Template query key
   * @param tag - Template identifier
   * @param locale - ISO locale code
   * @returns Query cache key array
   */
  template: (tag: string, locale: string) => ['order-import-template', tag, locale],
};
